import type { AnimationFlow } from '@/types/shared';

export const modal_overlay: AnimationFlow = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

export const modal_panel: AnimationFlow = {
  initial: {
    opacity: 0,
    y: 5,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 15,
  },
};
